import DropdownOptionsMenu from 'global/components/forms/elements/DropdownOptionsMenu'
import { openExternal } from 'global/viewSettings/helpers/settingsLinks'
import React from 'react'

export const FooterExternal = ({
  _icons,
  _sportCollections,
  districtLink,
  googleSheetsId,
  handlers,
  latestSeason,
  mediaUrl,
  selectedYear,
  sportsKey,
  sportsSeason_selectedPdks,
  updateColor,
  disabled_media,
  _sportSeasonalsKeys,
  pathViews,
}) => {

  const handleOpenUrl_district = () => window.open(districtLink, '_blank')
  const handleOpenUrl_sport = () => openExternal.firebaseDbDirect(pathViews, ['sports', sportsKey])
  const handleOpenUrl_seasonal = (e) => openExternal.firebaseDbDirect(pathViews, ['_seasonals', sportsSeason_selectedPdks?.seasonals])
  const handleOpenUrl_seasonMatches = () => openExternal.firebaseDbDirect(pathViews, [_sportCollections._matches_seasonal, sportsSeason_selectedPdks?.seasonMatches])
  const handleOpenUrl_teams = () => openExternal.firebaseDbDirect(pathViews, [_sportCollections._teams_seasonal, sportsSeason_selectedPdks?.teams_seasonal])
  // const handleOpenUrl_teams_seasonal = () => openExternal.firebaseDbDirect(pathViews, [_sportCollections._teams_seasonal, pdk_matches_seasonal])
  const handleOpen_googleSheet = () => openExternal.googleSheets(googleSheetsId)
  const handleOpen_mediaLink = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    const formattedDate = `${year}-${month}-${day}`;
    const _link = mediaUrl.replace('TODAYSDATE', formattedDate)
    window.open(_link, '_blank')
  }

  const ddb = (menuButtons, value, caption, icon, direction, color, disabled) => <DropdownOptionsMenu
    menuButtons={menuButtons}
    value={value}
    caption={caption}
    icon={icon}
    direction={direction}
    color={color}
    disabled={disabled}
    upward={true}
    ignoreCaption={true}
  />

  const buttons_footer = () => {

    const btns_data = []
    const btns_media = []
    const btns_ext = []

    if (sportsSeason_selectedPdks?.seasonals) {
      const _sid = sportsSeason_selectedPdks?.seasonals
      btns_ext.push({ oc: handleOpenUrl_seasonal, caption: 'Open Seasonal DB (' + _sid + ')', icon: _icons.open, color: 'orange' })
    }

    if (sportsKey) {
      btns_ext.push({ oc: handleOpenUrl_sport, caption: 'Open Sports DB (' + sportsKey + ')', icon: _icons.open, color: 'orange' })
    }

    if (sportsSeason_selectedPdks?.seasonMatches) {
      btns_ext.push({ oc: handleOpenUrl_seasonMatches, caption: 'Open Matches Seasonal DB (' + sportsSeason_selectedPdks?.seasonMatches + ')', icon: _icons.open, color: 'orange' })
    }

    if (sportsSeason_selectedPdks?.teams_seasonal) {
      btns_ext.push({ oc: handleOpenUrl_teams, caption: 'Open Teams Seasonal DB (' + sportsSeason_selectedPdks?.teams_seasonal + ')', icon: _icons.open, color: 'orange' })
    }

    if (districtLink) {
      btns_ext.push({ oc: handleOpenUrl_district, caption: 'Open District Website', icon: _icons.open, color: 'orange' })
    }

    if (googleSheetsId) {
      btns_ext.push({ oc: handleOpen_googleSheet, caption: 'Open Google Sheet', icon: _icons.open, color: 'orange' })
    }

    if (mediaUrl) {
      btns_ext.push({ oc: handleOpen_mediaLink, caption: 'Open Media', icon: _icons.open, color: 'orange' })
    }


    const clickOptions_new = { clickType: 'createNew', isNew: true, updateType: 'createNew' }
    const clickOptions_backup = { clickType: 'backupSeason', isBackup: true, updateType: 'backupSeason' }
    const clickOptions_media = { clickType: 'media', isMedia: true, updateType: 'media' }
    const clickOptions_mediaAlignment = { clickType: 'mediaAlignment', isMedia: true, updateType: 'mediaAlignment' }

    const _selectedYearPlusOne = selectedYear + 1

    if (!_.includes(_sportSeasonalsKeys, _selectedYearPlusOne?.toString())) {
      btns_data.push({ oc: handlers?.handleCreateSeasonFromPrevious, icon: 'arrow right', caption: 'Add New Season From Previous (' + latestSeason + ')', clickOptions: clickOptions_new, color: updateColor })
    }

    btns_data.push({ oc: handlers?.handleClick_commitSeasonal, icon: 'save', caption: 'Backup Season (' + latestSeason + ')', clickOptions: clickOptions_backup, color: updateColor })
    btns_data.push({ oc: handlers?.handleClick_fixSeasonals, icon: 'save', caption: 'Fix Seasonals', clickOptions: clickOptions_backup, color: updateColor })
    // btns_data.push({ oc: handlers?.handleClick_pasteSeasonals, icon: 'paste', caption: 'Paste Alignment', clickOptions: clickOptions_backup, color: updateColor })
    // btns_data.push({ oc: handlers?.handleClick_pasteSchedule, icon: 'paste', caption: 'Paste Schedule', clickOptions: clickOptions_backup, color: updateColor })

    if (selectedYear) {
      // btns_media.push({ oc: handleClick_getMedia_records, icon: 'arrow right', caption: 'Get Media Records (' + selectedYear + ')', clickOptions: clickOptions_mediaAlignment, color: updateColor })
      btns_media.push({ oc: handlers?.handleClick_getMedia_alignments, icon: 'arrow right', caption: 'Get Media Alignments (' + selectedYear + ')', clickOptions: clickOptions_mediaAlignment, color: updateColor })
      btns_media.push({ oc: handlers?.handleClick_getMedia_results, icon: 'arrow right', caption: 'Get Media Results (' + selectedYear + ')', clickOptions: clickOptions_media, color: updateColor })
      btns_media.push({ oc: handlers?.handleClick_ammendMediaSeason, icon: 'arrow right', caption: 'Ammend Media Season (' + selectedYear + ')', clickOptions: clickOptions_mediaAlignment, color: updateColor })
      btns_media.push({ oc: handlers?.handleClick_getGoogle_results, icon: 'arrow right', caption: 'Get Google Media Results (' + selectedYear + ')', clickOptions: clickOptions_media, color: updateColor })
      // btns_media.push({ oc: createGoogleSheet, icon: 'arrow right', caption: 'Create Google Sheet', clickOptions: clickOptions_media, color: updateColor })
    }

    return <div>
      {btns_ext.length > 0 && ddb(btns_ext, null, 'External Options', _icons.open, null, 'orange')}
      {btns_data.length > 0 && ddb(btns_data, null, 'Data Options', 'list ul', null, 'blue')}
      {btns_media.length > 0 && ddb(btns_media, null, 'Media Options', 'list ul', null, 'purple', disabled_media)}
    </div>
  }

  return buttons_footer()

}
